import type { StyleSpecification } from 'maplibre-gl';
import desktopStyle from '@/map-styles/osm-bright.json';
import { transitStopLayers } from '@/map-styles/transit-layers';

const TILEJSON_URL = 'https://tiles.maps.prawel.pl/world.json';
const ASSET_ROOT = new URL(
  `${import.meta.env.BASE_URL}map-assets`,
  globalThis.location?.origin ?? 'https://maps.prawel.pl'
).href;

export function createMapStyle(): StyleSpecification {
  // Clone the snapshot before adapting URLs and adding the desktop's runtime layers.
  const mapStyle = structuredClone(
    desktopStyle
  ) as unknown as StyleSpecification;

  mapStyle.name = 'Prawel OSM Bright';
  mapStyle.sources.protomaps = {
    ...desktopStyle.sources.protomaps,
    type: 'vector',
    url: TILEJSON_URL,
  };
  mapStyle.glyphs = `${ASSET_ROOT}/fonts/{fontstack}/{range}.pbf`;
  mapStyle.sprite = `${ASSET_ROOT}/sprites/light`;

  // Match OfflineMapDataset.enhanceRailwayLines in everything-app.
  const railwayIndex = mapStyle.layers.findIndex(
    (layer) => layer.id === 'roads_rail'
  );
  const railwayLayer = mapStyle.layers[railwayIndex];
  if (railwayLayer?.type === 'line') {
    mapStyle.layers.splice(railwayIndex, 0, {
      ...railwayLayer,
      id: 'everything-basemap-rail-casing',
      paint: {
        'line-color': '#596772',
        'line-opacity': 0.9,
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          3,
          0,
          6,
          0.4,
          10,
          1.4,
          14,
          3.2,
          18,
          8.5,
        ],
      },
    });
    railwayLayer.paint = {
      'line-color': '#f1f4f5',
      'line-opacity': 0.96,
      'line-dasharray': [0.65, 0.55],
      'line-width': [
        'interpolate',
        ['exponential', 1.5],
        ['zoom'],
        3,
        0,
        6,
        0.2,
        10,
        0.75,
        14,
        1.9,
        18,
        5.5,
      ],
    };
  }

  mapStyle.layers.push(...structuredClone(transitStopLayers));
  return mapStyle;
}
